import { render, staticRenderFns } from "./GridActionsDictionary.vue?vue&type=template&id=58045144&scoped=true&"
import script from "./GridActionsDictionary.vue?vue&type=script&lang=js&"
export * from "./GridActionsDictionary.vue?vue&type=script&lang=js&"
import style0 from "./GridActionsDictionary.vue?vue&type=style&index=0&id=58045144&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58045144",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58045144')) {
      api.createRecord('58045144', component.options)
    } else {
      api.reload('58045144', component.options)
    }
    module.hot.accept("./GridActionsDictionary.vue?vue&type=template&id=58045144&scoped=true&", function () {
      api.rerender('58045144', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/actionsDictionary/grid/GridActionsDictionary.vue"
export default component.exports